export default "__VITE_ASSET__e8a957a2__"